<template>
  <el-dialog
    :title="title"
    :visible.sync="showDialog"
    width="800px"
    :close-on-click-modal="false"
    :before-close="clearDialog"
    class="dialog"
  >
    <el-form label-suffix="：" class="detail-form">
      <el-row>
        <el-col :span="24">
          <!--品目名称-->
          <el-form-item
            v-if="'itemName' in translateObject"
            :label="translateObject.itemName.label"
          >
            <span>
              {{ materialInfo[translateObject.itemName.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <!--品目编码-->
          <el-form-item
            v-if="'itemCode' in translateObject"
            :label="translateObject.itemCode.label"
          >
            <span>
              {{ materialInfo[translateObject.itemCode.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!--数量-->
          <el-form-item
            v-if="'itemNum' in translateObject"
            :label="translateObject.itemNum.label"
          >
            <span>
              {{ materialInfo[translateObject.itemNum.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--参数型号-->
          <el-form-item
            v-if="'itemModel' in translateObject"
            :label="translateObject.itemModel.label"
          >
            <span>
              {{ materialInfo[translateObject.itemModel.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--品牌/制造商-->
          <el-form-item
            v-if="'itemBrand' in translateObject"
            :label="translateObject.itemBrand.label"
          >
            <span>
              {{ materialInfo[translateObject.itemBrand.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--单位-->
          <el-form-item
            v-if="'unitType' in translateObject"
            :label="translateObject.unitType.label"
          >
            <span>
              {{ materialInfo[translateObject.unitType.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--预算单价-->
          <el-form-item
            v-if="!isSupplier && 'unitPrice' in translateObject"
            :label="translateObject.unitPrice.label"
          >
            <span>
              {{ materialInfo[translateObject.unitPrice.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!--预算总价-->
          <el-form-item
            v-if="!isSupplier && 'totalPrice' in translateObject"
            :label="translateObject.totalPrice.label"
          >
            <span>
              {{ materialInfo[translateObject.totalPrice.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--税率-->
          <el-form-item
            v-if="'taxRate' in translateObject"
            :label="translateObject.taxRate.label"
          >
            <span>
              {{ materialInfo[translateObject.taxRate.key] || ' - ' }}
            </span>
            <span class="m-l-10">%</span>
          </el-form-item>
        </el-col>

        <el-col v-if="'factory' in translateObject" :span="12">
          <!--工厂编码-->
          <el-form-item :label="translateObject.factory.label">
            <span>
              {{ materialInfo[translateObject.factory.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!--交货地点-->
          <el-form-item
            v-if="'deliveryAddress' in translateObject"
            :label="translateObject.deliveryAddress.label"
          >
            <span>{{ deliveryAddress }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!--交货时间-->
          <el-form-item
            v-if="'deliveryDay' in translateObject"
            :label="translateObject.deliveryDay.label"
          >
            <span>
              {{ materialInfo[translateObject.deliveryDay.key] || ' - ' }}
            </span>
            <span class="m-l-10">天</span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!--使用部门-->
          <el-form-item
            v-if="'useDept' in translateObject"
            :label="translateObject.useDept.label"
          >
            <span>
              {{ materialInfo[translateObject.useDept.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!--科目分配类别-->
          <el-form-item
            v-if="'subType' in translateObject"
            :label="translateObject.subType.label"
          >
            <span>
              {{ getSubTypeLabel(materialInfo[translateObject.subType.key]) || ' - ' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <!-- 采购执行人 -->
          <el-form-item
            v-if="'executorName' in translateObject"
            :label="translateObject.executorName.label"
          >
            <span>
              {{ materialInfo[translateObject.executorName.key] || '-' }}
            </span>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <!--备注-->
          <el-form-item
            v-if="'remarks' in translateObject"
            :label="translateObject.remarks.label"
          >
            <span>
              {{ materialInfo[translateObject.remarks.key] || ' - ' }}
            </span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <!--附件上传-->
          <el-form-item
            v-if="'fileGroupId' in translateObject"
            :label="translateObject.fileGroupId.label"
          >
            <upload
              v-if="materialInfo[translateObject.fileGroupId.key]"
              :props-data="{
                groupIdBefore: materialInfo[translateObject.fileGroupId.key],
                disabled: true
              }"
            />
            <span v-else>-</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="clearDialog">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Upload from '@/components/common/Upload/index'

// 数据字典
import { purchaseDemandSubTypeDict } from '@/dictionary/purchase-demand'

// 工具函数
import { strToThousands } from '@/utils/utils.js'

export default {
  name: 'MaterialDetailDialog',

  components: { Upload },

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    materialField: {
      type: Array,
      required: true
    },

    // 品目信息
    materialInfo: {
      type: Object,
      default: () => {}
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bidType: '',
          attachmentType: ''
        }
      }
    },

    isSupplier: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      // 表示默认字段对应的新字段，以及label
      translateObject: {},

      // 工具函数
      strToThousands,

      loading: false
    }
  },

  computed: {
    visible: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$emit('change', val)
      }
    },

    bizType() {
      return this.uploadParams.bizType
    },

    attachmentType() {
      return this.uploadParams.attachmentType
    },

    // 交货地点
    deliveryAddress() {
      const address =
        this.materialInfo[this.translateObject.deliveryAddress.key] || ''
      if (address.includes(',')) {
        return address.split(',')?.[1] || '-'
      }
      return address || '-'
    }
  },

  watch: {
    materialField: {
      handler: function(fileList) {
        const temp = {
          itemCode: '', // 品目编码
          itemName: '', // 品目名称
          itemNum: undefined, // 数量
          itemModel: '', // 参数型号
          itemBrand: '', // 品牌/制造商
          unitPrice: undefined, // 预算单价
          totalPrice: 0, // 总价，总价禁止填写，根据数量和预算单价自动计算
          taxRate: '', // 税率
          unitType: '', // 单位
          factory: '', // 工厂编码
          deliveryAddress: '', // 交货地点
          deliveryDay: '', // 交货天
          useDept: '', // 使用部门
          subType: '', // 科目分配类别
          executorName: '', // 采购执行人
          executorId: '', // 采购执行人id
          remarks: '', // 备注
          fileGroupId: '' // 附件组id
        }

        const translateObjectTemp = {}
        fileList.forEach(value => {
          if (value.prop in temp) {
            if (value.transProp) {
              translateObjectTemp[value.prop] = {
                key: value.transProp,
                label: value.label
              }
            } else {
              translateObjectTemp[value.prop] = {
                key: value.prop,
                label: value.label
              }
            }
          }
        })

        this.translateObject = translateObjectTemp
      }
    },
    immediate: true
  },

  methods: {
    // 关闭对话框时，执行的函数
    clearDialog() {
      this.$emit('change', false)
    },

    // 科目分配类别
    getSubTypeLabel(value) {
      return value
        ? purchaseDemandSubTypeDict.translate(value)?.label
        : value == purchaseDemandSubTypeDict.BLANK.value
          ? purchaseDemandSubTypeDict.BLANK.label
          : '-'
    }
  }
}
</script>

<style lang="scss" scoped>
.material-dialog {
  span {
    display: inline-block;
    max-width: pixel-to-rem($n: 360);
  }
}
::v-deep {
  .el-form-item__label {
    color: $second-text-color;
  }
  .el-form-item__content {
    color: $text-color;
  }
}
</style>
